import { Component, inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogActions, MatDialogContent, MatDialogTitle, MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';

import { TranslatePipe } from '@ngx-translate/core';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { faKey, faThumbsUp } from '@fortawesome/pro-regular-svg-icons';

@Component({
    selector: 'app-global-announcement-modal',
    imports: [
    MatDialogTitle,
    MatDialogContent,
    MatDialogActions,
    MatDialogModule,
    MatButtonModule,
    TranslatePipe,
    FaIconComponent
],
    templateUrl: './global-announcement-modal.component.html',
    styleUrl: './global-announcement-modal.component.scss'
})
export class GlobalAnnouncementModalComponent {
  readonly dialogRef = inject(MatDialogRef<GlobalAnnouncementModalComponent>);
  readonly data = inject<{ storageKey: string }>(MAT_DIALOG_DATA);

  onConfirm(): void {
    localStorage.setItem(this.data.storageKey, 'true');
    this.dialogRef.close(true);
  }

  protected readonly faThumbsUp = faThumbsUp;
  protected readonly faKey = faKey;
}

